<template>
  <WdsStack gap-sm direction-column class="filter-full-width">
    <WdsSelect
      v-model="selectedTypes"
      multi-select
      searchable
      :label="meta.filter.quickFilter ? '' : $t('Request type')"
      :list="typeOptions"
      :placeholder="$t('All request types')"
      can-deselect
      labels-primary
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { computed, ModelRef } from 'vue'
import { $t } from '@/composables/translation'
import { PaymentRequestType } from '@/gql/graphql'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

defineProps<{ meta: FilterMetaDataProp }>()

const selectedTypes: ModelRef<string[]> = defineModel({
  default: () => [],
})

const orderedTypes = [
  PaymentRequestType.Time,
  PaymentRequestType.Amount,
  PaymentRequestType.Expenses,
]

const typeLabels: Record<PaymentRequestType, string> = {
  [PaymentRequestType.Time]: 'Time',
  [PaymentRequestType.Amount]: 'Amount',
  [PaymentRequestType.Expenses]: 'Expenses',
}

const typeOptions = computed(() =>
  orderedTypes.map((type) => ({
    label: $t(typeLabels[type]),
    value: type,
  })),
)
</script>

